import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Config from '../../../Config';
import { isMobile } from 'react-device-detect';

const GenericGuideImage = (props) => {

    useEffect(() => {

    }, []);

    return (
        <div className='generic-guide-image'>
            <Image src={Config.epiBaseUrl + (isMobile ? props.iContent.imageMobile?.expandedValue?.url : props.iContent.imageWeb?.expandedValue?.url)} />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(GenericGuideImage);